const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes

type CacheEntry<T> = {
  data: T;
  editionId: string;
  timestamp: number;
};

function getCacheKey(key: string, editionId: string): string {
  return `festapp:${editionId}:${key}`;
}

export function getCached<T>(key: string, editionId: string): T | null {
  try {
    const raw = sessionStorage.getItem(getCacheKey(key, editionId));
    if (!raw) return null;

    const entry: CacheEntry<T> = JSON.parse(raw);

    // Validate edition match and TTL
    if (entry.editionId !== editionId) return null;
    if (Date.now() - entry.timestamp > CACHE_TTL_MS) {
      sessionStorage.removeItem(getCacheKey(key, editionId));
      return null;
    }

    return entry.data;
  } catch {
    return null;
  }
}

export function setCached<T>(key: string, data: T, editionId: string): void {
  try {
    const entry: CacheEntry<T> = {
      data,
      editionId,
      timestamp: Date.now(),
    };
    sessionStorage.setItem(getCacheKey(key, editionId), JSON.stringify(entry));
  } catch {
    // Ignore storage errors (quota exceeded, etc.)
  }
}
